import { Navigate, Route, Routes } from "react-router-dom"

import { NAMES_ROUTES } from "@/const/routes.constants"
import { isFeatureFlagMaybe } from "@/domain/user"
import { isSelfHosted } from "@/helpers/self-hosted.helper"
import { useFeatureFlags } from "@/hooks/useUser"
import { ApplicationsPage } from "./components/pages/ApplicationsPage"
import { BaseImagesPage } from "./components/pages/BaseImagesPage"
import { BranchesPage } from "./components/pages/BranchesPage"
import { ImagesPage } from "./components/pages/ImagesPage"
import { SbomPage } from "./components/pages/SbomPage"
import { VirtualMachinesPage } from "./components/pages/VirtualMachinesPage"

export const DiscoveryPage = () => {
  const { DISCOVERY } = NAMES_ROUTES
  const vmInstancesEnabledFF = useFeatureFlags("vmInstancesEnabled")
  const notSelfHosted = !isSelfHosted()
  const useVmRoute =
    !!vmInstancesEnabledFF || isFeatureFlagMaybe(vmInstancesEnabledFF)

  return (
    <Routes>
      <Route path={`/${DISCOVERY.BRANCH}`} element={<BranchesPage />} />
      <Route
        path={`/${DISCOVERY.APPLICATIONS}`}
        element={<ApplicationsPage />}
      />
      <Route path={`/${DISCOVERY.IMAGES}`} element={<ImagesPage />} />
      <Route path={`/${DISCOVERY.SBOM}`} element={<SbomPage />} />
      {notSelfHosted && (
        <Route
          path={`/${DISCOVERY.BASE_IMAGES}`}
          element={<BaseImagesPage />}
        />
      )}
      {useVmRoute && (
        <Route path={`/${DISCOVERY.VM}`} element={<VirtualMachinesPage />} />
      )}
      <Route
        path="/*"
        element={
          <Navigate to={`/${DISCOVERY.ROOT}/${DISCOVERY.BRANCH}`} replace />
        }
      />
    </Routes>
  )
}
